module.exports = __webpack_public_path__ + "img/logo.948d378a.svg";